import axios from './axios'
import axiosRaw from 'axios'
import { API_CONFIG } from '../config/constants'
import { generateAuthHeaders } from '../utils/auth'

export const checkToken = (userData) => {
    return axios.request({
        url: `${API_CONFIG.BASE_URL}/v2/user/token/verify`,
        method: 'post',
        data: {
            username: userData.username,
            password: userData.password,
        },
    })
}

export const phonePasswordLogin = (credentials) => {
    const path = '/api/v1/auth/phone_password_login'
    const headers = generateAuthHeaders('POST', path)
    return axiosRaw.post('https://server.love-study.tech' + path, {
        phone: credentials.phone,
        password: credentials.password,
    }, { headers })
}

export const checkPhoneRegistered = (data) => {
    const path = '/api/v1/auth/check_phone_registered'
    const headers = generateAuthHeaders('POST', path)
    return axiosRaw.post('https://server.love-study.tech' + path, {
        phone: data.phone,
    }, { headers })
}

export const sendSmsCode = (data) => {
    const path = '/api/v1/auth/send_sms_code'
    const headers = generateAuthHeaders('POST', path)
    const payload = { phone: data.phone }
    if (data.target) payload.target = data.target
    return axiosRaw.post('https://server.love-study.tech' + path, payload, { headers })
}

export const register = (data) => {
    const path = '/api/v1/auth/register'
    const headers = generateAuthHeaders('POST', path)
    return axiosRaw.post('https://server.love-study.tech' + path, {
        phone: data.phone,
        password: data.password,
        phone_code: data.phone_code,
    }, { headers })
}

// 找回密码 / 重置密码。注意：后端接口约定的验证码字段名为 `id`（而非 phone_code）。
export const resetPassword = (data) => {
    const path = '/api/v1/auth/reset_password'
    const headers = generateAuthHeaders('POST', path)
    return axiosRaw.post('https://server.love-study.tech' + path, {
        phone_code: data.phone_code,
        phone: data.phone,
        password: data.password,
    }, { headers })
}

export const generateAccount = (validityPeriod) => {
    return axios.request({
        url: '/v1/auth/generate_account',
        method: 'post',
        data: {
            validity_period: validityPeriod,
        },
    })
}
